import { Component, OnInit, OnDestroy, Input, SimpleChanges, OnChanges } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AppBarActionsService, AppBarAction } from "./app-bar-actions.service";
import { debounceTime } from "rxjs/operators";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
    selector: "ifc-app-bar-actions",
    templateUrl: "./app-bar-actions.component.html",
    styleUrls: ["./app-bar-actions.component.css"],
    standalone: false
})
export class AppBarActionsComponent implements OnInit, OnDestroy, OnChanges {
  @Input() menuMobileAllowed = true;

  data: AppBarActionsComponentData;
  actions: AppBarAction[];
  visibility: Record<string, boolean> = { menu_hidden: false, mobile: false };

  constructor(
    private route: ActivatedRoute,
    private service: AppBarActionsService
  ) {
    this.actions = service.actions;
  }

  click(action: AppBarAction) {
    this.service.invoke(action.id);
  }

  ngOnInit() {
    this.route.data
      .pipe(untilDestroyed(this))
      .subscribe((it: AppBarActionsComponentData) => {
        this.data = it;
        this.updateVisibility();
      });

    this.service.changed
      .pipe(debounceTime(500), untilDestroyed(this))
      .subscribe((it: AppBarAction[]) => {
        this.actions = it;
        this.updateVisibility();
      });
  }

  ngOnDestroy() {
    this.service.clearAll();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['menuMobileAllowed']){
      this.updateVisibility();
    }
  }

  fixDisappearIOSBug() {
    const styleNode = document.createElement("style");
    styleNode.type = "text/css";
    styleNode.id = "panel-fix";
    styleNode.appendChild(
      document.createTextNode(".mat-menu-panel{overflow: initial !important;}")
    );
    document.getElementsByTagName("head")[0].appendChild(styleNode);
    setTimeout(() => {
      styleNode.remove();
    }, 500);
  }

  private updateVisibility(): void {
    this.visibility.menu_hidden = this.menuMobileAllowed && this.data?.appBarActions?.menuMobile;
    this.visibility.mobile = this.menuMobileAllowed && this.data?.appBarActions?.menuMobile && this.actions?.length > 0;
  }
}

export interface AppBarActionsComponentData {
  appBarActions: {
    menuMobile: boolean;
  };
}
